import { styled, TextField } from '@mui/material';

type SLabelProps = {
  start: boolean;
};

type STextFieldProps = {
  firstInput: boolean;
  startHint: boolean;
  endHint: boolean;
};

export const STextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'firstInput' && prop !== 'startHint' && prop !== 'endHint',
})<STextFieldProps>(({ startHint, endHint, firstInput }) => ({
  '& fieldset': {
    ...(firstInput
      ? { borderRadius: startHint ? 0 : '8px 0 0 8px' }
      : { borderLeft: 0, borderRadius: endHint ? 0 : '0 8px 8px 0' }),
  },
  '&:hover fieldset': {
    ...(!firstInput ? { borderLeft: '1px solid' } : {}),
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      ...(!firstInput ? { borderLeft: '2px solid' } : {}),
    },
  },
}));

export const SLabel = styled('div')<SLabelProps>(({ start, theme }) => ({
  backgroundColor: theme.palette.grey[100],
  fontWeight: 600,
  fontSize: '14px',
  color: theme.palette.text.secondary,
  border: '1px solid',
  borderColor: theme.palette.grey[500_32],
  borderRadius: start ? '8px 0 0 8px' : '0 8px 8px 0',
  padding: '8px 8px',
  minWidth: '40px',
  textAlign: 'center',
  ...(start ? { borderRight: 0 } : { borderLeft: 0 }),
}));

export const SDateLabel = styled('div')<SLabelProps>(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  fontWeight: 600,
  fontSize: '14px',
  color: theme.palette.text.secondary,
  border: '1px solid',
  borderColor: theme.palette.grey[500_32],
  borderRadius: '8px 0 0 8px',
  padding: '8px 17px',
  borderRight: 0,
  position: 'relative',
  minWidth: '40px',
}));
